import React from 'react';

function EditableTextField({ name, value, onChange, editable, type = 'text', unit }) {
  const editableTypeAttr = type === 'text' ? undefined : type;
  return (
    <>
      {editable ? (
        <input
          type={editableTypeAttr}
          name={name}
          onChange={onChange}
          className='edit-input'
          value={value}
        />
      ) : (
        <input
          name={name}
          onChange={onChange}
          className='project-detail-input'
          disabled
          value={value}
        />
      )}
      {unit ? <>{' '}<span className='unit-label'>{unit}</span></> : null}
    </>
  );
}

export default EditableTextField;
